
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069-1760.508a9.111 9.111 0 003.672-.747 9.726 9.726 0 005.078-5.075 9.43 9.43 0 000-7.334 9.731 9.731 0 00-5.093-5.086 9.406 9.406 0 00-7.324 0 9.731 9.731 0 00-5.083 5.083 9.4 9.4 0 00.007 7.337 9.758 9.758 0 005.08 5.075 9.087 9.087 0 003.663.747zm-3.194-5.468a.825.825 0 01-.82-.83.788.788 0 01.244-.576l2.607-2.608-2.607-2.6a.8.8 0 01-.244-.586.763.763 0 01.244-.581.813.813 0 01.576-.229.775.775 0 01.586.234l2.617 2.607 2.618-2.615a.8.8 0 01.586-.244.817.817 0 01.82.82.82.82 0 01-.244.586l-2.608 2.608 2.6 2.6a.82.82 0 01.244.586.811.811 0 01-.234.591.8.8 0 01-.6.239.854.854 0 01-.6-.244l-2.588-2.6-2.6 2.6a.822.822 0 01-.597.242z"}})])])
          )
        }
      }
    